import IApp from './app.model';
import { SeverityExc, StackTraceElement } from './log.model';

export enum LoglyticsType {
  MESSAGE = 'loglyticsMessage',
  EXCEPTION = 'loglyticsException', 
}

export class LoglyticsTypeUtil {
  static values() {
    return Object.values(LoglyticsType);
  }
}

export enum LoglyticsStatus {
  OPEN = 'open',
  FIXED = 'fixed',
  IGNORED = 'ignored'
}

export class LoglyticsStatusUtil {
  static values() {
    return Object.values(LoglyticsStatus);
  }
}

export interface IIssueAnalysisLocation {
  path: string;
  line?: number;
  url?: string;
}

export interface IIssueFix {
  path: string;
  language: string;
  originalCode: string;
  fixedCode: string;
  startLine?: number;
  endLine?: number;
}

export interface IIssueAnalysis {
  summary: string;
  rootCause: string;
  location?: IIssueAnalysisLocation;
  suggestedFix: string;
  fixes?: IIssueFix[];
  prUrl?: string;
  model?: string;
  createdAt: Date;
}

export interface ILoglytics {
  key: string;
  app: IApp | string;
  type: LoglyticsType;
  severity: SeverityExc;
  analysis?: IIssueAnalysis;
  // isObfuscated: boolean;
  // daily?: {
  //   date: Date,
  //   count: number;
  //   sessions: number;
  //   devices: number;
  //   users: number;
  //   appVersion: string[];
  //   osVersion: string[]; 
  //   sampleList: {
  //     session: ISession | Types.ObjectId;
  //     log: string;
  //   } [];
  // }[],
  status?: LoglyticsStatus;
  resolvedOnVersion?: string; // newest version the issue was seen on when marked fixed
  regressedAt?: Date;
  regressedInVersion?: string;
  movedFrom?: string;
  // membersRead: IMember[] | Types.ObjectId[] | string[];
  lastAlert?: Date;

  // children?: ILoglyticsBase[];
  count: number;
  appVersion: string[];
  osVersion: string[];
  devices: number;
  sessions?: number;
  // users?: number;
  dateHistogram?: {
    date: Date,
    count: number;
    affected: number;
    total: number;
    // users: number;
  }[];
}

export interface ILoglyticsMessage extends ILoglytics {
  tag: string;
  message: string;
  function: string;
  fileName: string;
  lineNumber: number;
  className: string; // only in android 
  stackTrace?: StackTraceElement[]; // for future adding maybe also to normal log messages
  callStackSymbols?: string[]; // for future adding maybe also to normal log messages
  exception?: { // in the case that a developer added a log message
    name: string;
    reason: string;
    stackTrace: StackTraceElement[];
  };
}

export interface ILoglyticsException extends ILoglytics {
  name: string;
  reason: string;
  stackTrace: StackTraceElement[];
  callStackSymbols: string[];
}